import React from "react";
import { Routes, Route } from "react-router-dom";

import Reports from "../component/Reports";
import AuditReport from "../component/Reports/Audit";
import SageMakerUsage from "../component/Reports/SageMaker";
import SnowflakeUsage from "../component/Reports/Snowflake";
import JobEngineUsage from "../component/Reports/JobEngineUsage";
import HostedAppUsage from "../component/Reports/HostedAppUsage";
import PrivateRoute from "./privateRoute";
import DataAIUsage from "../component/Reports/DataAIUsage";
import WorkspaceAccess from "../component/Reports/WorkspaceAccess";

const ReportsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Reports />} />
      <Route path="/audit-history" element={<AuditReport />} />
      <Route
        path="/hosted-app-usage"
        element={
          <PrivateRoute moduleName="HOSTED_APP_USAGE">
            <HostedAppUsage />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/sagemaker-usage"
        element={
          <PrivateRoute moduleName="SAGEMAKER_USAGE">
            <SageMakerUsage />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/snowflake-usage"
        element={
          <PrivateRoute moduleName="SNOWFLAKE_USAGE">
            <SnowflakeUsage />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/job-engine"
        element={
          <PrivateRoute moduleName="JOB_ENGINE_REPORT">
            <JobEngineUsage />
          </PrivateRoute>
        }
      ></Route>

      <Route
        path="/data-ai"
        element={
          <PrivateRoute moduleName="DATA_AI_REPORT">
            <DataAIUsage />
          </PrivateRoute>
        }
      ></Route>

      <Route
        path="/workspace-access"
        element={
          <PrivateRoute moduleName="WORKSPACE_ACCESS_REPORT">
            <WorkspaceAccess />
          </PrivateRoute>
        }
      ></Route>
    </Routes>
  );
};

export default ReportsRoutes;
